import React, { useState, useRef, useEffect } from 'react';
import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons';
import { Switch, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography  } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {insert, update, getById} from '../../../../apis/VariablesFormulaApi';
import Highlighter from "react-highlight-words";
import {variable_formula} from '@app/constants/variablesFormula';
import _ from 'lodash';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            if(response.ok){
                message.success('Se actualizó correctamente la variable!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente la variable!');
            }
        }

        setModified(true);
        onClose(true);
    }

    const onClose = (reload)=>{
      finish(reload ?? modified);
      setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        nombre: null,
                        descripcion: null,
                        clase: null,
                        ayuda: null,
                        tipo_dato: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            setInitialValues(item);
        }
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                       
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        hideRequiredMark 
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="nombre"
                                    label="Nombre"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un nombre',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un nombre" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="descripcion"
                                    label="Descripción"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una descripción',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una descripción" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="ayuda"
                                    label="Ayuda"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega una ayuda',
                                    },
                                    ]}
                                >
                                    <TextArea placeholder="Por favor agrega una descripción" rows={4} maxLength={6}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="tipo_dato"
                                    label="Tipo de Dato"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona un tipo de dato',
                                    },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona un tipo de dato">
                                        {
                                            variable_formula.list.map((item)=><Option value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="clase"
                                    label="Clase"
                                    >
                                    <Switch checkedChildren={'Sistema'} unCheckedChildren={'Usuario'}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;